<template>
  <p>
    {{ $_translations.value.modal_resubscribe_via_web_terms_pt1 }}
    <span class="white_bold">
      {{ $_translations.value.modal_resubscribe_via_web_terms_pt2 }}
    </span>
    {{ $_translations.value.modal_resubscribe_via_web_terms_pt3 }}
    <a :href="appLegalResources.terms" target="_blank">
      {{ $_translations.value.modal_resubscribe_via_web_terms_pt4 }}
    </a>
    {{ $_translations.value.modal_resubscribe_via_web_terms_pt5 }}
  </p>
</template>

<script setup>
import useAppResourcesHook from '@/hooks/useAppResources.js';

const { appLegalResources } = useAppResourcesHook();
</script>
